<template>
  <div class="plan-info">
    <h4 class="global-h4" style="margin-bottom: 20px">Your Shrpa Platform subscription provides you access to</h4>

    <!-- Plan info section -->
    <div class="plan-info-section plan-info__section">
      <div class="global-h5 plan-info-section__title">Creator Visits</div>
      <div class="plan-info-section__text">Work with trusted creators who visit your destination and deliver content for your marketing.</div>
    </div>
    <!-- / Plan info section -->

    <div class="plan-info__divider"></div>

    <!-- Plan info section -->
    <div class="plan-info-section plan-info__section">
      <div class="global-h5 plan-info-section__title">Community Uploads</div>
      <div class="plan-info-section__text">Let your community upload photos directly into your library for easy use across channels.</div>
    </div>
    <!-- / Plan info section -->

    <div class="plan-info__divider"></div>

    <!-- Plan info section -->
    <div class="plan-info-section plan-info__section">
      <div class="global-h5 plan-info-section__title">Website Enhancements</div>
      <div class="plan-info-section__text">
        <p class="global-p">Inspire your visitors with amazing UGC photos and videos on your website.</p>
      </div>
    </div>
    <!-- / Plan info section -->

    <!-- Plan info section -->
    <div class="plan-info-section plan-info__section">
      <div class="global-h5 plan-info-section__title">Dedicated Support</div>
      <div class="plan-info-section__text">
        <p class="global-p">Get expert support to set up Shrpa and ensure smooth, successful Creator Visits.</p>
      </div>
    </div>
    <!-- / Plan info section -->
  </div>
</template>

<script setup lang="ts"></script>

<style scoped lang="scss">
@import "./plan-info.scss";
</style>
